import React from 'react';
import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';

const MissionIntro = () => (
	<motion.section
		initial={{ opacity: 0, y: 50 }}
		animate={{ opacity: 1, y: 0 }}
		transition={{ duration: 0.8 }}
		style={{
			minHeight: '100vh',
			display: 'flex',
			alignItems: 'center',
			scrollSnapAlign: 'start',

			backgroundSize: 'cover',
			backgroundPosition: 'center',
			backgroundRepeat: 'no-repeat',
		}}>
		<Container
			className='d-flex flex-column justify-content-center align-items-center text-center px-3 px-md-5 bg-waterColorPink'
			style={{ minHeight: '100vh' }}>
			<h1
				className='display-5 fw-bold mb-4 text-center'
				style={{ color: '#384971' }}>
				About Us
			</h1>
			<p
				className='fs-5 lh-base mb-0 text-center '
				style={{ maxWidth: '700px' }}>
				<strong>A safe harbor for creative hearts.</strong>
				<br />
				At Color Your Voice, we believe in more than great performances
				— we believe in confident, expressive young people. Through
				music and storytelling, we help students grow skills that serve
				them on stage and far beyond it.
			</p>
		</Container>
	</motion.section>
);

export default MissionIntro;
